<template>
  <div class="ls-pagination--container">
    <span class="ls-pagination--info"> {{ paginationInfo }} </span>

    <BPagination
      :total="pagination.totalItems"
      :current="pagination.currentPage"
      :range-before="2"
      :range-after="2"
      order="is-centered"
      size=""
      :per-page="pagination.itemsPerPage"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @change="changePage"
    >
      <BPaginationButton
        slot="previous"
        slot-scope="props"
        :page="props.page"
        test-id="previous-button"
      >
        <LsIcon type="chevron" size="md" class="ls-pagination--chevron-left" />
      </BPaginationButton>
      <BPaginationButton :id="`page${props.page.number}`" slot-scope="props" :page="props.page">
        {{ props.page.number }}
      </BPaginationButton>
      <BPaginationButton slot="next" slot-scope="props" :page="props.page" test-id="next-button">
        <LsIcon type="chevron" size="md" />
      </BPaginationButton>
    </BPagination>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsIcon } from '@/components/common';

export default {
  name: 'LsPagination',
  components: {
    LsIcon,
  },
  props: {
    pagination: VueTypes.shape({
      totalItems: VueTypes.number.isRequired,
      currentPage: VueTypes.number.isRequired,
      itemsPerPage: VueTypes.number.isRequired,
    }).isRequired,
    changePage: VueTypes.func.isRequired,
    tableType: VueTypes.string.def('Properties'),
  },
  computed: {
    paginationInfo() {
      const { currentPage, itemsPerPage, totalItems } = this.pagination;

      let firstNumber = 1;
      if (currentPage > 1) {
        firstNumber = (currentPage - 1) * itemsPerPage + 1;
      }
      const lastNumber = firstNumber + this.perPage - 1;

      return `Showing ${firstNumber} - ${lastNumber} of ${totalItems} ${this.tableType}`;
    },
    perPage() {
      return this.pagination.currentPage * this.pagination.itemsPerPage < this.pagination.totalItems
        ? this.pagination.itemsPerPage
        : Math.floor(this.pagination.totalItems % 10);
    },
  },
};
</script>

<style lang="scss">
.ls-pagination--container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;

  .ls-pagination--chevron-left {
    transform: rotate(180deg);
  }

  @media (max-width: $mobile-max-width) {
    justify-content: center;
    flex-direction: column-reverse;

    .ls-pagination--info {
      margin-top: 10px;
    }
  }
}

.pagination-previous,
.pagination-next {
  background-color: $primary-light;
  border-color: transparent !important;
  border-radius: 0;
}

.pagination-previous[disabled],
.pagination-next[disabled] {
  background-color: $primary-light !important;
}

.pagination-list {
  justify-content: space-evenly !important;

  .pagination-link.is-current {
    background-color: $primary;
    color: white !important;
  }
}

.pagination-ellipsis {
  font-size: 15px !important;
}

.pagination-link {
  border-color: transparent !important;
  border-radius: 0;
}

.themed-app {
  .pagination-previous,
  .pagination-next {
    background-color: $theme-color-primary-light;
  }

  .pagination-previous[disabled],
  .pagination-next[disabled] {
    background-color: $theme-color-primary-light !important;
  }

  .pagination-list {
    .pagination-link.is-current {
      background-color: $theme-color-primary;
    }
  }
}
</style>
